import { render, staticRenderFns } from "./CircularLoader.vue?vue&type=template&id=8855965c&scoped=true&"
import script from "./CircularLoader.vue?vue&type=script&lang=js&"
export * from "./CircularLoader.vue?vue&type=script&lang=js&"
import style0 from "./CircularLoader.vue?vue&type=style&index=0&id=8855965c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8855965c",
  null
  
)

export default component.exports